import { render, staticRenderFns } from "./modal-cmp.vue?vue&type=template&id=f08fdaf4&scoped=true"
import script from "./modal-cmp.vue?vue&type=script&lang=js"
export * from "./modal-cmp.vue?vue&type=script&lang=js"
import style0 from "./modal-cmp.vue?vue&type=style&index=0&id=f08fdaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08fdaf4",
  null
  
)

export default component.exports